var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":_vm.destination}},[_c('genButton',{attrs:{"imgSrc":_vm.imgSrc}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }